import { FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { TableCell, TableRow } from '@digdir/designsystemet-react';

import { OppvarmingFjernvarme } from '../../../../../../types/registration/userInput';
import {
  AccentedTableRow,
  LeftBorderCell
} from '../../../../../expertRegistration/json/enhet/upload/fileReview/components/styledComponents';

interface OppvarmingFjernvarmeProps {
  fjernvarme: OppvarmingFjernvarme | undefined;
}
export const OppvarmingFjernvarmeView: FC<OppvarmingFjernvarmeProps> = ({ fjernvarme }) => {
  const { t } = useTranslation('', { keyPrefix: 'expertToolsJSON.summary.tekniskutstyr.oppvarming.fjernvarme' });
  const { t: tCommon } = useTranslation('', { keyPrefix: 'expertToolsJSON.summary.common' });

  return (
    fjernvarme && (
      <Fragment>
        <AccentedTableRow $isSecondarySection>
          <TableCell colSpan={2}>{t('header')}</TableCell>
        </AccentedTableRow>

        {fjernvarme.gulvvarme && (
          <Fragment>
            <AccentedTableRow>
              <TableCell colSpan={2}>{t('gulvvarme.label')}</TableCell>
            </AccentedTableRow>
            <TableRow>
              <TableCell>{t('gulvvarme.label')}</TableCell>
              <LeftBorderCell>{t(`gulvvarme.${fjernvarme.gulvvarme}`)}</LeftBorderCell>
            </TableRow>
          </Fragment>
        )}

        {fjernvarme.radiator && (
          <Fragment>
            <AccentedTableRow>
              <TableCell colSpan={2}>{t('radiator.label')}</TableCell>
            </AccentedTableRow>
            <TableRow>
              <TableCell>{t('radiator.label')}</TableCell>
              <LeftBorderCell>{t(`radiator.${fjernvarme.radiator}`)}</LeftBorderCell>
            </TableRow>
          </Fragment>
        )}

        {fjernvarme.varmesentralInstallasjonsAr && (
          <TableRow>
            <TableCell>{t('varmesentralInstallasjonsAr')}</TableCell>
            <LeftBorderCell>{fjernvarme.vetVarmesentralInstallasjonsAr ? fjernvarme.varmesentralInstallasjonsAr : tCommon('innstallasjonsArUkjent', { byggAr: fjernvarme.varmesentralInstallasjonsAr })}</LeftBorderCell>
          </TableRow>
        )}
      </Fragment>
    )
  );
};
